import { render, staticRenderFns } from "./CardAlternative.vue?vue&type=template&id=2896182d&scoped=true&"
import script from "./CardAlternative.vue?vue&type=script&lang=js&"
export * from "./CardAlternative.vue?vue&type=script&lang=js&"
import style0 from "./CardAlternative.vue?vue&type=style&index=0&id=2896182d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896182d",
  null
  
)

export default component.exports